import styled from 'styled-components'

export const Root = styled.div`
  width: 100%;
`

export const Title = styled.h1`
  margin: 0 0 8px;
  font-family: 'Roboto', sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  color: #002a6d;
`

/** Same footer as the question bank: secondary on the left, primary on the right. */
export const Footer = styled.div`
  text-align: right;
  padding-top: 24px;

  button {
    height: 40px;
    margin-left: 8px;
    border-radius: 8px;
    padding: 0 12px;
    color: #4c4c4c !important;
    background-color: #f0f0f0;
    border: none;
    font-weight: 700;
    cursor: pointer;

    &:hover {
      background-color: #e8e8e8;
    }
  }

  div {
    float: right;

    button {
      color: white !important;
      background-color: #0085ff !important;

      &:hover {
        background-color: #0069f2 !important;
      }

      &:disabled {
        opacity: 0.48;
      }
    }
  }
`
